import React from "react";
import GoogleChart from "../../../../components/charts/googleChart/googleChart";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { actionCreators } from "../redux/numberOfActiveMembersBySagas";

const LineOrTableChart = () => {
  const dispatch = useDispatch();

  const {
    chartData: { data_table: { cols = [], rows = [] } = {}, options } = {},
    frozenTableData: { cols: frozenCols = [], rows: frozenRows = [] } = {},
    table_view
  } = useSelector((state) => {
    const {
      chartData,
      frozenTableData,
      selectedFilters: { table_view }
    } = state.numberOfActiveMembersBy;
    return {
      chartData,
      frozenTableData,
      table_view
    };
  }, shallowEqual);
  const switchView = (view) => dispatch(actionCreators.updateTableView(view));

  return (
    <>
      <GoogleChart
        chartName="number_of_active_members_by_status_chart"
        width="1350px"
        height={400}
        chartType={table_view ? "Table" : "LineChart"}
        isTableView={table_view}
        enableEventListeners
        showAdditionTooltip={false}
        rows={rows}
        columns={cols}
        options={options}
        switchView={switchView}
      />
      {options?.doubleTableView ? (
        <div className="frozen-table">
          <GoogleChart
            chartName=""
            width="1350px"
            height={400}
            chartType="Table"
            rows={frozenRows}
            columns={frozenCols}
            enableEventListeners
            isTableView
            showXLSX
            options={options}
            showAdditionTooltip={false}
          />
        </div>
      ) : null}
    </>
  );
};

export default LineOrTableChart;
